var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12.6667C6.06971 12.6667 6.66667 12.0697 6.66667 11.3333C6.66667 10.5969 6.06971 10 5.33333 10C4.59695 10 4 10.5969 4 11.3333C4 12.0697 4.59695 12.6667 5.33333 12.6667Z",
    stroke: "#179EF8",
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 12.6667C12.7377 12.6667 13.3346 12.0697 13.3346 11.3333C13.3346 10.5969 12.7377 10 12.0013 10C11.2649 10 10.668 10.5969 10.668 11.3333C10.668 12.0697 11.2649 12.6667 12.0013 12.6667Z",
    stroke: "#179EF8",
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7013 11.3333H10.0013V4.4C10.0013 4.17909 9.82223 4 9.6013 4H0.667969",
    stroke: "#179EF8",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76667 11.3327H2.4C2.17909 11.3327 2 11.1536 2 10.9327V7.66602",
    stroke: "#179EF8",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 6H3.9987",
    stroke: "#179EF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H13.7401C13.8981 6 14.0414 6.09309 14.1056 6.23755L15.2989 8.9224C15.3216 8.9736 15.3333 9.02893 15.3333 9.08487V10.9333C15.3333 11.1543 15.1543 11.3333 14.9333 11.3333H13.6667",
    stroke: "#179EF8",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.334H10.6667",
    stroke: "#179EF8",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/delivery-truck.ccfa615891c4cf4f91510321427bc173.svg";
export { ForwardRef as ReactComponent };